import ProcessRequestExecutionState from '@app/model/process-request/ProcessRequestExecutionState';

export enum MetaradarRefreshState {
	READY = 'READY',
	IN_PROGRESS = 'IN_PROGRESS',
	COOLDOWN = 'COOLDOWN'
}

export class MetaradarRefreshStatus {
	status: MetaradarRefreshState;
	executionState?: ProcessRequestExecutionState;
	retryAfterSeconds?: number;

	constructor(data: MetaradarRefreshStatus) {
		this.status = data.status;
		this.executionState = data.executionState
			? new ProcessRequestExecutionState(data.executionState)
			: undefined;
		this.retryAfterSeconds = data.retryAfterSeconds;
	}
}
